export const tableOfContentsStyle = (theme) => ({
  tableOfContentsBody: {
    width: '100%',
    borderRadius: 8,
    border: ({ noBorder }) => !noBorder && `1px solid ${theme.neutral[0]}`,
    overflow: 'hidden'
  }
})
